import {color} from '@chakra-ui/react'
import {pxToRem} from '../../utills/pxToRem'

// Coupon Card
export const normalTextStyle = {
    fontSize: pxToRem(13),
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const couponCardStyle = (isModalView = false) => ({
    align: 'center',
    p: isModalView ? {base: '15px 18px', lg: '36.5px'} : {base: '10px', lg: '20px'},
    bg: 'gray.75',
    borderRadius: isModalView ? {base: '15.282px', lg: '18.784px'} : pxToRem(10),
    spacing: isModalView ? {base: pxToRem(20), lg: pxToRem(37)} : {base: '15px', lg: '20px'},
    cursor: isModalView ? 'auto' : 'pointer',
    maxWidth: isModalView
        ? {base: pxToRem(298), lg: pxToRem(509)}
        : {base: 'auto', lg: pxToRem(271)},
    m: '0 !important'
})

export const couponCardHeadingIconStyle = (isModalView = false) => ({
    color: 'cav_red',
    width: isModalView
        ? {base: pxToRem(203.061), lg: pxToRem(351.268)}
        : {base: pxToRem(132.88), lg: pxToRem(187)},
    height: isModalView
        ? {base: pxToRem(41.086), lg: pxToRem(70.344)}
        : {base: pxToRem(26.88), lg: pxToRem(37.45)}
})

export const promoHeadingStyle = (isModalView = false) => ({
    ...normalTextStyle,
    fontWeight: 'medium',
    fontSize: isModalView
        ? {base: pxToRem(18.338), lg: pxToRem(24.419)}
        : {base: 'xs', lg: pxToRem(13)},
    letterSpacing: isModalView ? {base: pxToRem(1.528), lg: pxToRem(1.878)} : pxToRem(1),
    mb: '0'
})

export const promoCodeStyle = (isModalView = false) => ({
    ...normalTextStyle,
    fontSize: isModalView
        ? {base: pxToRem(18.338), lg: pxToRem(24.419)}
        : {base: 'xs', lg: pxToRem(13)},
    letterSpacing: isModalView ? {base: pxToRem(1.528), lg: pxToRem(1.878)} : pxToRem(1)
})

export const copyIconStyle = (isModalView = false) => ({
    width: isModalView
        ? {base: pxToRem(15.409), lg: pxToRem(20.661)}
        : {base: '10.08px', lg: '11px'},
    height: isModalView ? {base: pxToRem(16.811), lg: pxToRem(22.542)} : {base: '11px', lg: '12px'},
    mr: isModalView ? {base: pxToRem(7.64), lg: pxToRem(9.39)} : '5px'
})

export const copyPromoCodeStyle = (isModalView = false) => ({
    ...normalTextStyle,
    fontSize: isModalView ? {base: pxToRem(15.282), lg: pxToRem(22.541)} : {base: '2xs', lg: 'xs'},
    letterSpacing: isModalView ? {base: pxToRem(1.528), lg: pxToRem(1.878)} : pxToRem(1),
    fontWeight: 'medium',
    color: 'cav_red',
    textTransform: 'uppercase',
    textDecoration: 'underline'
})

export const promoCardExpiryTextStyle = (isModalView = false) => ({
    ...normalTextStyle,
    color: 'cav_light_input_gray',
    fontSize: isModalView
        ? {base: pxToRem(18.338), lg: pxToRem(22.541)}
        : {base: 'xs', lg: pxToRem(13)},
    letterSpacing: isModalView ? {base: pxToRem(1.528), lg: pxToRem(1.878)} : pxToRem(1)
})

export const promoCardNoteTextStyle = (isModalView = false) => ({
    ...normalTextStyle,
    color: 'cav_light_input_gray',
    textAlign: 'center',
    mt: isModalView
        ? {base: `${pxToRem(1.44)} !important`, lg: `${pxToRem(4.62)} !important`}
        : {base: `${pxToRem(1)} !important`, lg: `${pxToRem(2)} !important`},
    fontSize: isModalView
        ? {base: pxToRem(18.338), lg: pxToRem(24.419)}
        : {base: 'xs', lg: pxToRem(13)},
    letterSpacing: isModalView ? {base: pxToRem(1.528), lg: pxToRem(1.878)} : pxToRem(1)
})

export const couponValueStyle = (isModalView = false) => ({
    alignItems: 'center',
    aspectRatio: '1',
    position: 'relative',
    textAlign: 'center',
    justifyContent: 'center',
    // width: isModalView
    //     ? {base: pxToRem(175.744), lg: pxToRem(291.72)}
    //     : {base: pxToRem(115), lg: pxToRem(156)}
    // TODO: May be required if px to px match is needed
    height: isModalView
        ? {base: pxToRem(178), lg: pxToRem(342.42)}
        : {base: pxToRem(135), lg: pxToRem(184)}
})

export const couponIconStyle = (isModalView = false) => ({
    width: '100% !important',
    height: '100% !important',
    color: 'cav_red',
    aspectRatio: 1
})

const textShadowStyle = (isModalView = false) => ({
    textShadow: isModalView
        ? {
              base: `
        -4px -4px 0 #F1F1F1,
         4px -4px 0 #F1F1F1,
        -4px  4px 0 #F1F1F1,
         4px  4px 0 #F1F1F1,
         0px -4px 0 #F1F1F1,
         0px  4px 0 #F1F1F1,
        -4px  0px 0 #F1F1F1,
         4px  0px 0 #F1F1F1
        `,
              lg: `
        -5px -5px 0 #F1F1F1,
         5px -5px 0 #F1F1F1,
        -5px  5px 0 #F1F1F1,
         5px  5px 0 #F1F1F1,
         0px -5px 0 #F1F1F1,
         0px  5px 0 #F1F1F1,
        -5px  0px 0 #F1F1F1,
         5px  0px 0 #F1F1F1
              `
          }
        : {
              base: `
        -2px -2px 0 #F1F1F1,
         2px -2px 0 #F1F1F1,
        -2px  2px 0 #F1F1F1,
         2px  2px 0 #F1F1F1,
         0px -2px 0 #F1F1F1,
         0px  2px 0 #F1F1F1,
        -2px  0px 0 #F1F1F1,
         2px  0px 0 #F1F1F1
      `,
              lg: `
        -4px -4px 0 #F1F1F1,
         4px -4px 0 #F1F1F1,
        -4px  4px 0 #F1F1F1,
         4px  4px 0 #F1F1F1,
         0px -4px 0 #F1F1F1,
         0px  4px 0 #F1F1F1,
        -4px  0px 0 #F1F1F1,
         4px  0px 0 #F1F1F1
      `
          }
})

export const amountContainerStyle = (isModalView = false) => ({
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'absolute',
    textAlign: 'center',
    top: '52%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    '.currency-symbol': {
        ...textShadowStyle(isModalView),
        fontSize: isModalView
            ? {base: pxToRem(54), lg: pxToRem(90)}
            : {base: pxToRem(31), lg: pxToRem(53)},
        color: 'cav_red',
        fontWeight: 'bold',
        letterSpacing: {base: pxToRem(1.858), lg: pxToRem(2.545)}
    },
    margin: '0 !important'
})

export const discountValueStyle = (isModalView = false) => ({
    whiteSpace: 'nowrap',
    ...normalTextStyle,
    fontSize: isModalView
        ? {base: pxToRem(86), lg: pxToRem(150)}
        : {base: pxToRem(61.943), lg: pxToRem(84.847)},
    fontWeight: 'bold',
    letterSpacing: {base: pxToRem(1.858), lg: pxToRem(2.545)},
    textTransform: 'uppercase',
    ...textShadowStyle(isModalView),
    bg: 'transparent',
    color: 'cav_red',
    margin: '0 !important'
})

export const rewardTextStyle = (isModalView = false) => ({
    fontSize: isModalView
        ? {base: pxToRem(24), lg: pxToRem(32)}
        : {base: pxToRem(18), lg: pxToRem(16)},
    fontStyle: 'normal',
    fontWeight: 'semibold',
    lineHeight: 'normal',
    letterSpacing: {base: pxToRem(2), lg: pxToRem(3)},
    textTransform: 'uppercase',
    color: 'cav_red',
    mt: '0 !important',
    mb: pxToRem(5)
})
